quoteModule.controller('productSettingsDialogController',
    ['$scope', 'productSettingsDialogConstants', 'additionalSecuritySections', 'authorizationService', '$mdDialog', '$q',
    function ($scope, productSettingsDialogConstants, additionalSecuritySections, authorizationService, $mdDialog, $q) {

        var ctrl = this;
        $scope.loading = false;
        ctrl.promiseDlgSaveProfitType = $q.defer();
        ctrl.promiseDlgSaveDealerSettings = $q.defer();

        var promises = [
            ctrl.promiseDlgSaveProfitType.promise,
            ctrl.promiseDlgSaveDealerSettings.promise
        ];

        if (isDealerAdditionalMarkupAEditAllowed()) {
            ctrl.promiseDlgSaveDealerPacks = $q.defer();
            promises.push(ctrl.promiseDlgSaveDealerPacks.promise);
        }

        if (isDealerOverRemitEditAllowed()) {
            ctrl.promiseDlgSaveOverRemit = $q.defer();
            promises.push(ctrl.promiseDlgSaveOverRemit.promise);
        }

        $q.all(promises)
            .then(function() {
                $mdDialog.hide();
            });

        ctrl.hide = function() {
            $scope.$broadcast('productSettingsSave');
        };

        ctrl.cancel = function() {
            $scope.$broadcast('productSettingsCancel');
            $mdDialog.cancel();
        };

        ctrl.views = angular.copy(productSettingsDialogConstants);

        var activeView = "";  // none visible yet

        if(!isDealerAdditionalMarkupAEditAllowed()) {
            delete ctrl.views.additionalMarkup;
        }

        if(!isDealerOverRemitEditAllowed()) {
            delete ctrl.views.overRemit;
        }

        ctrl.setActiveView  = function (viewName) {
            activeView = viewName;
            console.log("activeView", activeView);
        };

        ctrl.isViewActive = function(viewName) {
            return (activeView === viewName) ? true : false;
        };

        function isDealerAdditionalMarkupAEditAllowed() {
            return authorizationService.isUrlAccessibleForUser(additionalSecuritySections.additionalMarkup);
        }

        function isDealerOverRemitEditAllowed() {
            //kre - COM 435 , we need to add a condition to see if the provider has access to overRemit
            return authorizationService.isUrlAccessibleForUser(additionalSecuritySections.overRemit) && authorizationService.isUIElementAccessibleForUser(productSettingsDialogConstants.overRemit);
        }

        function init() {
            var initialView =_.contains(ctrl.views, ctrl.initialView || "") // ctrl.initialView is passed as a local via $mdDialog
                ? ctrl.initialView
                : ctrl.views.defaults;

            ctrl.setActiveView(initialView);
        }

        init();

    }]);